import React, { useMemo } from "react";
import Badge from "ui/Badge/Badge";
import { PlacementType } from "ui/Tooltip/Tooltip";
import Counter from "common/Counter/Counter";
import Price from "common/Price/Price";
import Close from "assets/icons/10x10/close.svg";
import { formattedMoney } from "helpers/money";
import { getImageSrcWithSize } from "helpers/image";
import { formatDate } from "helpers/date";
import { IMAGE_SIZE_200_200, PRICES } from "constants/variables";
import styles from "./ItemPreview.module.scss";

type Props = {
  item: Entity.Cart.Item;
  onRemove?: () => void;
  onChangeCount: (value: number) => void;
  submitting: boolean;
  tooltipPlacement?: PlacementType;
  isEmployeeMode: boolean;
};

const ItemPreview: React.FC<Props> = ({
  item,
  onRemove,
  onChangeCount,
  submitting,
  tooltipPlacement,
  isEmployeeMode,
}: Props) => {
  const { quantity, product } = item;
  const isAvailable = product.availableForOrder || product.availableForBooking;
  const imageSrc = getImageSrcWithSize(product?.image, IMAGE_SIZE_200_200);
  const maxQuantity = product.maxQuantity;

  const dateExpired = useMemo(() => {
    return item.product.expirationDate;
  }, [item]);

  return (
    <div className={styles.itemPreview}>
      <div className={styles.remove} onClick={onRemove}>
        <Close />
      </div>
      {product.image ? (
        <div className={styles.itemPreviewImage}>
          <img src={imageSrc} />
        </div>
      ) : (
        <div className={styles.itemPreviewImagePlaceholder}>
          <img
            src="/img/product/image-placeholder.svg"
            alt="Изображение отсутствует"
          />
        </div>
      )}
      <div className={styles.itemPreviewInner}>
        <div className={styles.itemPreviewInfo}>
          {isEmployeeMode && PRICES[item.priceTypeID] && (
            <div>
              <Badge color="darkYellow">{PRICES[item.priceTypeID]}</Badge>
              {item.priceTypeID == 4 && dateExpired && (
                <span className={styles.itemPreviewDateExpired}>
                  До {formatDate(dateExpired, "DD.MM.YYYY")}
                </span>
              )}
            </div>
          )}
          <p className={styles.itemPreviewTitle}>{product.name}</p>
        </div>

        {isAvailable && (
          <div className={styles.itemPreviewControls}>
            <div className={styles.itemPreviewPrice}>
              <Price
                bonuses
                hasOnlyBookingPrices={product.hasOnlyBookingPrices}
                price={item.totalAmount}
                priceOld={item.amount}
                discount={item.totalDiscount}
                className={styles.previewPrice}
              />
            </div>
            {item.totalAmount !== 0 && (
              <div className={styles.itemPreviewCounter}>
                <Counter
                  disabled={submitting}
                  value={quantity}
                  onChange={onChangeCount}
                  size="small"
                  max={maxQuantity}
                  tooltipPlacement={tooltipPlacement}
                />
                <span className={styles.priceForOne}>
                  {formattedMoney(item.price)} ₽/шт.
                </span>
              </div>
            )}
          </div>
        )}
        {!isAvailable && (
          <div className={styles.itemPreviewNotAvailable}>Нет в наличии</div>
        )}
      </div>
    </div>
  );
};

export default ItemPreview;
